import React from 'react';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import styles from './PagesStyle/certificateStyle';
import { left } from '@cloudinary/url-gen/qualifiers/textAlignment';


const Header = ({ title, currentDate }) => {
  const getCurrentDateInUSAFormat = () => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const year = today.getFullYear();
    return `${month}/${day}/${year}`;
  };


  const formattedDate = currentDate || getCurrentDateInUSAFormat();

  console.log('Formatted Date in Header:', formattedDate);

  console.log('Current Date in Header:', formattedDate); // Debugging


  return (
    <View style={styles.header}>
      <View style={styles.headerContainer}>
        <View style={styles.leftHeaderContainer}>
          <Text style={styles.companyHeaderText}>Appraisal Engine Inc</Text>
          <Text style={styles.leftHeadertext}>1372 Peachtree Street NE Atlanta, GA 303090</Text>
          <Text style={styles.leftHeadertext}>Atlanta, GA 303090</Text>
          <Text style={styles.leftHeadertext}>1-877-667-2326</Text>
        </View>
        <View style={styles.rightHeaderContainer}>
          <Image style={styles.headerImage} src="/Logo (1).png" />
          <Text style={styles.rightHeadertext}>
            {formattedDate}
          </Text>
        </View>
      </View>
    </View>
  );
};



const formatDate = (dateString) => {
  if (!dateString) return ''; // Handle empty or invalid dates

  const [year, month, day] = dateString.split('-'); // Split ISO date format (YYYY-MM-DD)
  return `${month}/${day}/${year}`; // Return in MM/DD/YYYY format
};



// Main document component
const AppraisalCertificate = ({ formData, selectedImages, currentDate, notes = [] }) => {
  console.log('FORM DATA IN PDF: ', formData);
  const notesArray = typeof notes === 'string'
    ? notes.split('\n')
    : Array.isArray(notes)
      ? notes
      : [];


  const getFontSize = (totalChars) => {
    if (totalChars > 1100) return 8;
    if (totalChars > 650) return 9;
    if (totalChars > 400) return 10;
    if (totalChars > 200) return 12;
    if (totalChars > 100) return 12;
    return 12;
  };


  

  // Calculate total characters from all notes
  const totalCharacters = notes.join('').length;
  const dynamicFontSize = getFontSize(totalCharacters);
  const yearMakeModel = formData?.['Year Make Model'] || '';
  const isLongYearMakeModel = yearMakeModel.length > 16;


  return (
    <Document>

      <Page size="LETTER" style={styles.page}>
        <Header title="Page 1 Header" />
        <View style={styles.section}>
          <View style={styles.centeredContainer}>
            <Text style={styles.bigText}>CERTIFICATE OF APPRAISAL</Text>
          </View>







          <View>
            {isLongYearMakeModel ? (
              // Alternative Layout for Longer Text
              <View style={styles.tableFirstPage}>
                <View style={styles.firstWhiteRow}>
                  <Text style={[styles.textWhiteRow, { left: 2 }]}>Year / Make / Model</Text>
                  <Text style={[styles.textWhiteRow, { marginLeft: 230 }]}>
                    Vehicle Identification Number
                  </Text>
                </View>

                <View style={[styles.blueRow, { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }]}>
                  {/* Adjusted Text Container */}
                  <Text
                    style={[
                      styles.textBlueRow,
                      {
                        fontSize: yearMakeModel.length > 50 ? 10 : 12, // Adjust font size dynamically
                        lineHeight: 1.2,
                        wordBreak: 'break-word',
                        whiteSpace: 'pre-wrap', // Allow text wrapping
                        width: 350, // Increased width for longer text
                        textAlign: 'left',
                        paddingRight: 1,
                        marginLeft: 2
                      },
                    ]}
                    wrap
                  >
                    {yearMakeModel}
                  </Text>

                  {/* VIN Number */}
                  <Text
                    style={[styles.textBlueRowBigHeaderVin,]}
                  >
                    {formData?.['VIN Number'] || 'N/A'}
                  </Text>
                </View>

                <View style={styles.whiteRow}>
                  <Text style={[styles.textWhiteRow, { left: 2 }]}>Color</Text>
                  <Text style={[styles.textWhiteRow, {}]}>Grade And Pre-loss Condition</Text>
                  <Text style={[styles.textWhiteRowBigHeaderMA, {}]}>Market Area</Text>
                  <Text style={[styles.textWhiteRowBigHeaderOdometer, {}]}>Odometer</Text>
                </View>
                <View style={styles.blueRow}>
                  <Text style={[styles.textBlueRow, { left: 2 }]}>{formData?.['Vehicle Color'] || 'N/A'}</Text>
                  <Text style={styles.textBlueRowBigHeaderGrade}>
                    {formData?.['Grade'] || 'N/A'} / {formData?.['Pre-Loss Condition'] || 'N/A'}
                  </Text>
                  <Text style={styles.textBlueRowBigHeaderMA}>{formData?.['Market Area'] || 'N/A'}</Text>
                  <Text style={styles.textBlueRowBigHeaderMiles}>{formData?.['Miles'] || 'N/A'}</Text>
                </View>
              </View>
            ) : (
              // Default Layout
              <View style={styles.tableFirstPage}>
                <View style={styles.firstWhiteRow}>
                  <Text style={[styles.textWhiteRow, { left: 2 }]}>Year / Make / Model</Text>
                  <Text style={[styles.textWhiteRow, { marginLeft: 20 }]}>
                    Vehicle Identification Number
                  </Text>
                  <Text style={[styles.textWhiteRow, { paddingBottom: 1 }]}>Odometer Reading</Text>
                </View>

                <View style={styles.blueRow}>
                  <Text style={[styles.textBlueRow, { marginLeft: 2 }]}>{yearMakeModel}</Text>
                  <Text style={[styles.textBlueRowVIN, {}]}>{formData?.['VIN Number'] || 'N/A'}</Text>
                  <Text style={styles.textBlueRowMiles}>{formData?.['Miles'] || 'N/A'}</Text>
                </View>

                <View style={styles.whiteRow}>
                  <Text style={[styles.textWhiteRow, { left: 2 }]}>Color</Text>
                  <Text style={[styles.textWhiteRow, { marginLeft: 85 }]}>
                    Grade And Pre-loss Condition
                  </Text>
                  <Text style={[styles.textWhiteRow, {}]}>Market Area</Text>
                </View>

                <View style={styles.blueRow}>
                  <Text style={[styles.textBlueRow, { left: 2 }]}>{formData?.['Vehicle Color'] || 'N/A'}</Text>
                  <Text style={styles.textBlueRowGrade}>
                    {formData?.['Grade'] || 'N/A'} / {formData?.['Pre-Loss Condition'] || 'N/A'}
                  </Text>
                  <Text style={[styles.textBlueRowMA]}>{formData?.['Market Area'] || 'N/A'}</Text>
                </View>
              </View>
            )}
          </View>





          {/* Notes Section */}
          <View style={[styles.notesRow, { flexDirection: 'column', gap: 2 }]}>
            {notesArray.length > 0 ? (
              notesArray.map((note, index) => (
                <Text
                  key={index}
                  style={[
                    styles.textBlueRowNotes,
                    {
                      fontSize: dynamicFontSize,
                      left: -4,
                      width: '100%',
                      wordBreak: 'break-word',
                      textAlign: 'left',
                      paddingRight: 4,
                      lineHeight: 1.2,
                      whiteSpace: 'pre-wrap',
                    },
                  ]}
                  wrap
                >
                  {note}
                </Text>
              ))
            ) : (
              <Text style={[styles.textBlueRow, { fontSize: 12 }]}>No notes available.</Text>
            )}
          </View>


          <View style={[styles.textContainer]}>
            <View style={styles.textHeaderContainer}>
              <Text style={[styles.textHeader, { top: -25 }]}>Professional Appraisal Practice Compliance Statements</Text>
            </View>
            <View style={[styles.topicsTextContainer, { top: -25 }]}>
              <Text style={[styles.textBeliefs, { paddingBottom: 2 }]}>We certify that, to the best of our knowledge and belief that:</Text>

              <View style={styles.textRow}>
                <View style={[styles.circleIcon, { bottom: 15 }]} />
                <Text style={styles.topicsText}>
                  The reported analysis, opinions, and conclusions are limited only by the reported {'\n'}
                  assumptions and limiting conditions, and they represent my personal, impartial, {'\n'}
                  and unbiased professional analysis,
                  opinions, and conclusions.
                </Text>
              </View>

              <View style={styles.textRow}>
                <View style={[styles.circleIcon, { bottom: 8 }]} />
                <Text style={styles.topicsText}>
                  There is no present or prospective interest in the property that is the subject of{'\n'}this report.
                </Text>
              </View>

              <View style={styles.textRow}>
                <View style={[styles.circleIcon, { bottom: 8 }]} />
                <Text style={styles.topicsText}>
                  There is no bias with respect to any property that is the subject of this report or{'\n'}to the parties
                  involved with this assignment.
                </Text>
              </View>

              <View style={styles.textRow}>
                <View style={[styles.circleIcon, { bottom: 8 }]} />
                <Text style={styles.topicsText}>
                  The engagement in this assignment was not contingent upon developing or{'\n'}reporting predetermined results.
                </Text>
              </View>

              <View style={styles.textRow}>
                <View style={[styles.circleIcon, { bottom: 15 }]} />
                <Text style={styles.topicsText}>
                  The compensation for completing this assignment is not contingent upon the{'\n'}
                  reporting of a predetermined value or direction in value that favors the cause of{'\n'}
                  the client.
                </Text>
              </View>

              <View style={styles.textRow}>
                <View style={[styles.circleIcon, { bottom: 1 }]} />
                <Text style={styles.topicsText}>Significant or mass appraisal assistance was not provided to us.</Text>
              </View>


            </View>
          </View>







          <View style={{ top: -22 }}>
            <View style={styles.actualCashValueContainer}>
              <View style={styles.firstacvcontainer}>
                <Text style={styles.textAcv}>Actual Cash Value</Text>
              </View>
              <View style={styles.secondacvcontainer}>
                <Text style={styles.numbertext}>
                  {formData?.['Actual Cash Value']
                    ? `$${parseFloat(formData['Actual Cash Value']).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                    : '$0.00'}
                </Text>
              </View>
            </View>

            <View style={styles.valuationDataContainer}>
              <View style={styles.firstvaluationcontainer}>
                <Text style={styles.textvaluation}>Valuation Date</Text>
              </View>
              <View style={styles.secondValuationContainer}>
                <Text style={styles.dateText}>{formData?.['valuationDate'] ? formatDate(formData['valuationDate']) : 'No Date Provided'}</Text>
              </View>
            </View>

            <View style={styles.tonyLogoContainer}>
              <Image src="/logoTony.png" style={styles.tonyLogo} />
            </View>
          </View>
        </View>




        <View style={styles.footer}>
          <Text style={styles.footerText}>PAGE 1 / 4</Text>
        </View>

        {/*
        <View style={styles.lineFirst} />
        <View style={styles.lineSecond} />
        <View style={styles.lineThird} />
        */}

      </Page>



      <Page size="LETTER" style={styles.page}>
        <Header title="Page 1 Header" />
        <View style={styles.section}>
          <View style={[styles.centeredContainer]}>
            <Text style={styles.bigTextDefinitions}>VEHICLE CONDITION DEFINITIONS</Text>
          </View>
          <View style={styles.conditionTable}>

            <View style={styles.firstRowContainer}>
              <View style={styles.conditionTextContainer}><Text style={styles.tableHeaderText}>Condition</Text></View>
              <View style={styles.descriptionTextContainer}><Text style={[styles.tableHeaderText, { right: 335 }]}>Description</Text></View>
            </View>


            <View style={styles.otherRow}>
              <View style={styles.otherConditionTextContainer}><Text style={styles.textCondition}>Brand New</Text></View>
              <View style={styles.descriptionTextContainer}><Text style={styles.descriptionText}>A vehicle that is unused, untitled, zero miles, fresh from the manufacturer{'\n'}with no wear and tear, damage, or previous ownership.</Text></View>
            </View>


            <View style={styles.otherRow}>
              <View style={styles.otherConditionTextContainer}><Text style={styles.textCondition}>Showroom</Text></View>
              <View style={styles.descriptionTextContainer}><Text style={styles.descriptionText}>A vehicle very close to its original factory condition, with minimal wear and{'\n'}tear and no significant defects or issues. Usually used for demonstrations.</Text></View>
            </View>


            <View style={styles.otherRow}>
              <View style={styles.otherConditionTextContainer}><Text style={styles.textCondition}>Restored Original</Text></View>
              <View style={styles.descriptionTextContainer}><Text style={styles.descriptionText}>A vehicle returned to like-new condition through comprehensive repairs{'\n'}and refurbishments, often including original or upgraded parts.</Text></View>
            </View>


            <View style={styles.otherRow}>
              <View style={styles.otherConditionTextContainer}><Text style={styles.textCondition}>Restomod</Text></View>
              <View style={styles.descriptionTextContainer}><Text style={styles.descriptionText}>A restored vehicle upgraded with modern features, technology, or{'\n'}performance enhancements while retaining its classic design and charm.</Text></View>
            </View>


            <View style={styles.otherRow}>
              <View style={styles.otherConditionTextContainer}><Text style={styles.textCondition}>Excellent</Text></View>
              <View style={styles.descriptionTextContainer}><Text style={styles.descriptionText}>A well-maintained vehicle with no mechanical problems, minimal cosmetic{'\n'}flaws, and low wear and tear for its age.</Text></View>
            </View>


            <View style={styles.otherRow}>
              <View style={styles.otherConditionTextContainer}><Text style={styles.textCondition}>Good</Text></View>
              <View style={styles.descriptionTextContainer}><Text style={styles.descriptionText}>A vehicle in proper working order, with minor cosmetic issues and average{'\n'}wear for its age, but no significant mechanical defects.</Text></View>
            </View>


            <View style={styles.otherRow}>
              <View style={styles.otherConditionTextContainer}><Text style={styles.textCondition}>Fair</Text></View>
              <View style={styles.descriptionTextContainer}><Text style={styles.descriptionText}>A vehicle showing noticeable wear and tear, may have cosmetic or{'\n'}mechanical issues, but is still operable and safe to drive.</Text></View>
            </View>


            <View style={styles.otherRow}>
              <View style={styles.otherConditionTextContainer}><Text style={styles.textCondition}>Poor</Text></View>
              <View style={styles.descriptionTextContainer}><Text style={styles.descriptionText}>A vehicle with major cosmetic damage, significant mechanical issues, or{'\n'}extensive wear and tear, requiring substantial repairs to restore functionality.</Text></View>
            </View>


            <View style={styles.otherRow}>
              <View style={styles.otherConditionTextContainer}><Text style={styles.textCondition}>Inoperable</Text></View>
              <View style={styles.descriptionTextContainer}><Text style={styles.descriptionText}>A vehicle that cannot be driven due to mechanical failure, missing parts, or{'\n'}other critical issues.</Text></View>
            </View>


            <View style={styles.otherRow}>
              <View style={styles.otherConditionTextContainer}><Text style={styles.textCondition}>Parts Car</Text></View>
              <View style={styles.descriptionTextContainer}><Text style={styles.descriptionText}>A vehicle primarily used as a source of spare parts for other vehicles.{'\n'}It may not be operable or worth repairing.</Text></View>
            </View>


            <View style={styles.otherRow}>
              <View style={styles.otherConditionTextContainer}><Text style={styles.textCondition}>Junk</Text></View>
              <View style={styles.descriptionTextContainer}><Text style={styles.descriptionText}>A vehicle beyond repair or salvage, primarily valuable for scrap or recycling.</Text></View>
            </View>

            <View style={styles.line} />
            <View style={styles.line2} />
            <View style={styles.line3} />
            <View style={styles.line4} />
            <View style={styles.line5} />
            <View style={styles.line6} />
            <View style={styles.line7} />
            <View style={styles.line8} />
            <View style={styles.line9} />
            <View style={styles.line10} />
            <View style={styles.line11} />




          </View>
        </View>
        <View style={styles.verticalLine} />
        <View style={styles.footer}>
          <Text style={styles.footerText}>PAGE 2 / 4</Text>
        </View>
      </Page>



      <Page size="LETTER" style={styles.page}>
        <Header title="Page 3 Header" />
        <View style={styles.section}>
          <View style={styles.vehicleTextContainer}>
            <Text style={styles.vehicleText}>VEHICLE PICTURE</Text>
          </View>
          <View style={styles.carImgContainer}>
            {Array.isArray(selectedImages) && selectedImages.length === 0 ? (
              <Text style={styles.noImageText}>No image selected</Text> // Placeholder text
            ) : Array.isArray(selectedImages) && selectedImages.length === 1 ? (
              <Image src={selectedImages[0]} style={styles.carImage} />
            ) : (
              <View style={styles.imageGrid}>
                {Array.isArray(selectedImages) &&
                  selectedImages.map((image, index) => (
                    <Image key={index} src={image} style={styles.gridImage} />
                  ))}
              </View>
            )}
          </View>
        </View>
        <View style={styles.footer}>
          <Text style={styles.footerText}>PAGE 3 /4</Text>
        </View>
      </Page>


      
      <Page size="LETTER" style={styles.page}>
        <Header title="Page 2 Header" />
        <View style={styles.section2}>
          <View style={styles.certificationBusinessContainer}>
            <Text style={styles.certificationBusinessText}>CERTIFICATION OF BUSINESS RECORDS</Text>
          </View>

          <View style={styles.certificationContainer}>
            <View style={styles.firstPartContainer}>
              <Text style={styles.vehicleSubjectText}>Vehicle Subject to this Certification</Text>
            </View>
            <View style={styles.vinSpecialContainer}>
              <Text style={styles.vinSpecial}>{formData?.['VIN Number'] || 'N/A'}</Text>
            </View>
          </View>

          <View style={styles.textPersuantContainer}>
            <Text>
              {'     '}{'     '}{'     '}{'     '}{'     '}Pursuant to the evidentiary provisions of the Official Code of Georgia, including O.C.G.A. § 24-9-902-(11), I{'\n'}
              hereby certify, as the Records Custodian for True Appraisal, Inc. that the documents attached to this Certificate are true{'\n'}
              and correct reproductions of our records in connection with the client and case above, maintained by Appraisal Engine,{'\n'}
              Inc., and that these records:  (a) were made at or near the time of the occurrence of the matters set forth by, or from{'\n'}
              information transmitted by, a person with knowledge of each such matters;  (b) were kept in the course of regularly{'\n'}
              conducted activity of the facility; and (c) were made by the regularly conducted activity as a regular practice of the facility,{'\n'}
              all in accordance with the provisions of O.C.G.A. § 24-8-803(6).  I further certify that these documents include all records{'\n'}
              with the exception of :  (1) materials which are privileged or otherwise not subject to production; (2) materials not{'\n'}
              requested by the subpoena, request, or other instrument seeking production;  (3) materials not yet scanned or completed;{'\n'}
              and/or (4) materials which Appraisal Engine, Inc. has received from other third parties.
            </Text>
          </View>
          <View style={styles.swornContainer}>
            <Text style={styles.swornText}>Sworn to and subscribed before me on:</Text>
            <Text style={styles.swornDate}>{currentDate}</Text>
          </View>
          <Image style={styles.signImage} src="/signatureTony.png" alt="Tony Sign" />
          <Text style={styles.signatureText}>Signature of Records Custodian</Text>

          <View style={[{ top: 15 }]}>
            <View style={styles.publicSignatureContainer}>
              <Text style={styles.textPublicSignature}>Notary Public Signature:</Text>
              <View style={[styles.imgLine, {top: 3}]} />
            </View>
            <View style={[styles.publicSignatureContainer, { top: 68 }]}>
              <Text style={[styles.textPublicSignature, { top: 4 }]}>My Commision Expires:</Text>
              <View style={[styles.imgLine, {top: 5}]} />
            </View>
          </View>

          <View style={styles.officialSealContainer}>
            <Image src="officialSeal.png" alt="Official seal" />
          </View>

          <View style={styles.tonyContainer}>
            <Text style={styles.tonyText}>Tony Rached</Text>
            <Text style={styles.signatureRecordsText}>Signature of Records Custodian</Text>
          </View>
          <View>
            {/* ANM IMAGE WILL BE INSERTED HERE */}
          </View>
          <View style={styles.noteContainer}>
            <Text>
              NOTE:  Appraisal Engine, Inc. who is providing this Certificate in accordance with the self-authentication requirements of O.C.G.A. {'\n'}
              24-9-902(11) in lieu of incurring unnecessary time and expense of having its Records Custodian appear in Court.  The statute{'\n'}
              specifically imposes an obligation on any party intending to offer these records into evidence to provide written notice of such intention{'\n'}
              to all adverse parties and to make the records and this Certificate available for inspection sufficiently in advance of the offer to provide{'\n'}
              an adverse party with fair opportunity to challenge the records and the Certificate.
            </Text>
          </View>
        </View>
        <View style={styles.footer}>
          <Text style={styles.footerText}>PAGE 4 / 4</Text>
        </View>
      </Page>





    </Document>
  );
}; // <-- Component ends here

export default AppraisalCertificate;
